import Vue from 'vue'
import { attachOauthCallbackListener, runOidcBootstrap } from '@/plugins/rhAuth/oidc-bootstrap'

Vue.config.productionTip = false

runOidcBootstrap()
attachOauthCallbackListener()
